import { NgClass, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EmailSummaryDto } from '@workspace/data-types';
import { AuraHtmlShadowComponent, AvatarAuraComponent, LuxonDatePipe } from '@workspace/ng-aura';

@Component({
  selector: 'core-email-viewer',
  templateUrl: './email-viewer.component.html',
  imports: [
    MatIconButton,
    NgClass,
    MatIcon,
    LuxonDatePipe,
    TitleCasePipe,
    AuraHtmlShadowComponent,
    MatTooltipModule,
    MatDividerModule,
    MatButtonModule,
    RouterModule,
    AvatarAuraComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailViewerCoreComponent {
  private readonly _view = signal<'text' | 'html'>('html');
  readonly view = computed(() => this._view());

  email = input.required<EmailSummaryDto>();
  textWithBreaks = computed(() => {
    const raw = this.email()?.text ?? '';
    return raw
      .replace(/^\s+/gm, '') // remove leading spaces on each line
      .replace(/\n/g, '<br>'); // turn \n into <br>
  });

  setView(mode: 'text' | 'html') {
    this._view.set(mode);
  }
}
